const POST_LOGOUT_REDIRECT_KEY = 'postLogoutRedirectPath';

export const setPostLogoutRedirect = path => {
    const normalizedPath = String(path || '').trim();
    if (!normalizedPath || typeof window === 'undefined') {
        return;
    }

    window.__logoutRedirectTarget = normalizedPath;
    try {
        window.sessionStorage.setItem(POST_LOGOUT_REDIRECT_KEY, normalizedPath);
    } catch (error) {
        // Ignore sessionStorage failures and rely on in-memory fallback.
    }
};

export const getPostLogoutRedirect = () => {
    if (typeof window === 'undefined') {
        return null;
    }

    const memoryValue = String(window.__logoutRedirectTarget || '').trim();
    if (memoryValue) {
        return memoryValue;
    }

    try {
        const storedValue = String(window.sessionStorage.getItem(POST_LOGOUT_REDIRECT_KEY) || '').trim();
        return storedValue || null;
    } catch (error) {
        return null;
    }
};

export const clearPostLogoutRedirect = () => {
    if (typeof window === 'undefined') {
        return;
    }

    window.__logoutRedirectTarget = null;
    try {
        window.sessionStorage.removeItem(POST_LOGOUT_REDIRECT_KEY);
    } catch (error) {
        // Ignore sessionStorage failures.
    }
};
